export default {
  state: {
    knowledge: [],
  },
  getters: {
    "llm/knowledge/get": (state) => {
      console.log(state.knowledge);
      return state.knowledge;
    },
  },
  mutations: {
    "llm/knowledge/set": function (state, data) {
      state.knowledge = data;
    },
  },
  actions: {
    "llm/knowledge/get": async function ({ commit, dispatch }, { botID }) {
      try {
        dispatch("setLoader", true);
        const { data } = await this._vm.$http_rag.get(`/rag/files/${botID}`);
        dispatch("setLoader", false);
        commit("llm/knowledge/set", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    "llm/knowledge/getOne": async function ({ dispatch }, { id, botID }) {
      try {
        dispatch("setLoader", true);
        const { data } = await this._vm.$http_rag.get(
          `/rag/files/${botID}/${id}`
        );
        dispatch("setLoader", false);
        return data;
      } catch (err) {
        throw err;
      }
    },
    "llm/knowledge/add": async function ({ dispatch }, { botID, data }) {
      try {
        dispatch("setLoader", true);
        const res = await this._vm.$http_rag.post(`/rag/${botID}`, data);
        dispatch("setLoader", false);
        return res;
      } catch (err) {
        throw err;
      }
    },
    "llm/knowledge/update": async function ({ dispatch }, { botID, id, data }) {
      try {
        dispatch("setLoader", true);
        const res = await this._vm.$http_rag.put(`/rag/${botID}/${id}`, data);
        dispatch("setLoader", false);
        return res;
      } catch (err) {
        throw err;
      }
    },
    "llm/knowledge/delete": async function ({ dispatch }, { botID, id, data }) {
      try {
        dispatch("setLoader", true);
        const res = await this._vm.$http_rag.delete(
          `/rag/${botID}/${id}`,
          data
        );
        dispatch("setLoader", false);
        return res;
      } catch (err) {
        throw err;
      }
    },
  },
};
